import Button from './Button'
import getDisabledClass from '../../functions/getDisabledClass'

const ButtonSubmit = ({transIdSubmit, onSubmit, hasFixedPositionWrapper, disableTemporarily= false, disablePermanently = false}) => (
    <div className={getDisabledClass((hasFixedPositionWrapper ? '' : 'buttons-submit'), disableTemporarily, disablePermanently)}>
        <Button
            className="button-submit"
            transId={transIdSubmit}
            onClick={onSubmit}
            disabled={disableTemporarily || disablePermanently}
            hideText={false}
            type="submit"
        />
    </div>
)

export default ButtonSubmit